<template>
    <div id="filtroParaDashboard" class="column resumo-subsidio">
        <div class="container container_com-fundo container_com-margem">
            <loading :ativo="loading" />
            <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />

            <div class="logos print has-text-centered">
                <img src="../../assets/imagens/logo-relatorio-retrato.jpg" alt="">
            </div>
            <div class="cabecalho-dashboard">
                <h2 class="print title-print">Acompanhamento do saldo</h2>
                <div class="formulario">
                    <div class="grade__linha grade__linha_alinhar-vertical-a-base">
                        <div class="grade__coluna grade__coluna_3">
                            <label for="projeto">Projeto</label>
                            <select id="projeto" name="projeto" v-model="projeto" @change="atualizarDadosDoFiltro">
                                <option v-for="projeto in projetos" :value="projeto.Id">
                                    {{ projeto.Nome }}
                                </option>
                            </select>
                        </div>
                        <div class="grade__coluna grade__coluna_3">
                            <label for="cidade">Cidades</label>
                            <select id="cidade" name="cidade" v-model="cidade">
                                <option v-for="cidade in cidades" :value="cidade.Id">
                                    {{ cidade.Nome }}
                                </option>
                            </select>
                        </div>
                        <div class="grade__coluna grade__coluna_1">
                            <button type="submit" class="botao botao_contorno botao_cor-terciaria botao_medio"
                                @click="filtrar">
                                Filtrar
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="deveMostrarInvestimentoInicial">
                    <div v-show="valorTotalDoProjeto != null">
                        <div class="investimento-inicial">
                            <div class="icone">
                                <i class="fal fa-sack-dollar"></i>
                            </div>
                            <div class="valor">
                                {{ this.valorTotalDoProjeto }} <span>Investimento do projeto {{ this.projetoNome
                                    }}</span>
                            </div>
                        </div>
                        <button type="button" onclick="window.print()"
                            class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio">
                            <i class="fa fa-print" aria-hidden="true"></i>
                            Imprimir
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "../shared/Loading";
import Alerta from '../shared/Alerta';

export default {
    props: {
        valorTotalDoProjeto: {
            type: String,
            default: ''
        },
    },
    components: { Loading, Alerta },
    name: "filtroParaDashboard",
    data() {
        return {
            tipoDeAlerta: null,
            mensagemDeAlerta: null,
            cidades: null,
            cidade: null,
            loading: false,
            projetos: this.projetos || [],
            projeto: null,
            projetoNome: null,
            deveMostrarInvestimentoInicial: null,
            projetoEhMcmvCidades: false,
        };
    },
    watch: {
        valorTotalDoProjeto(newVal) {
            this.valorTotalDoProjeto = newVal;
        },
    },
    created() {
        this.obterProjetos();
    },
    methods: {
        atualizarDadosDoFiltro() {
            const projetoSelecionado = this.projetos.find(projeto => projeto.Id === this.projeto);
            this.projetoNome = projetoSelecionado ? projetoSelecionado.Nome : '';
            this.projetoEhMcmvCidades = projetoSelecionado && projetoSelecionado.Tipo === "McmvCidades";
            this.cidade = null;

            if (this.projetoEhMcmvCidades) {
                this.obterCidadesParaProjetoMcmv(this.projeto);
            }
            else {
                this.obterCidadesParaProjetos();
            }
        },
        filtrar() {
            const dadosDoFiltro = {
                idCidade: this.cidade,
                idProjeto: this.projeto,
                projetoNome: this.projetoNome,
                projetoEhMcmvCidades: this.projetoEhMcmvCidades
            };
            this.deveMostrarInvestimentoInicial = !this.projetoEhMcmvCidades && this.projetoNome != "Selecione o projeto";
            this.$emit('atualizarDadosDoFiltro', dadosDoFiltro);
        },
        tratarErro(error) {
            this.tipoDeAlerta = "erro";
            const mensagensDeErro = error.response.data.Message;
            this.mensagemDeAlerta = mensagensDeErro || "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte";
        },
        obterProjetos() {
            let url = "/Projeto/ObterVigentes";
            this.$api
                .get(url)
                .then((response) => {
                    this.projetos = [{ Id: null, Nome: "Selecione o projeto" }];
                    this.projetos = this.projetos.concat(response.data);

                    return response;
                })
                .catch((error) => {
                    this.tratarErro(error);
                });
        },
        obterCidadesParaProjetoMcmv(idProjeto) {
            let url = `/Cidade/ObterCidadesComEmendas/${idProjeto}`;
            this.$api
                .get(url)
                .then((response) => {
                    this.cidades = [{ Id: null, Nome: "Selecione uma cidade" }];
                    this.cidades = this.cidades.concat(response.data);
                    return response;
                })
                .catch((error) => {
                    this.tratarErro(error);
                });
        },
        obterCidadesParaProjetos() {
            let url = "/Cidade/ObterCidadesDosEmpreendimentos";
            this.$api
                .get(url)
                .then((response) => {
                    this.cidades = [{ Id: null, Nome: "Selecione uma cidade" }];
                    this.cidades = this.cidades.concat(response.data);
                    return response;
                })
                .catch((error) => {
                    this.tratarErro(error);
                });
        }
    }
};
</script>


// WEBPACK FOOTER //
// Filtro.vue?584d01ac